import { useEffect, useState } from 'react';
import { useAuiState } from '@assistant-ui/react';

export const useFailedMessageIds = (hasFailure: boolean): readonly string[] => {
    const lastUserMessageId = useAuiState((state) => [...state.thread.messages].reverse().find(({ role }) => role === 'user')?.id);
    const [failedIds, setFailedIds] = useState<string[]>([]);

    useEffect(() => {
        if (hasFailure && lastUserMessageId) {
            setFailedIds((ids) => [...ids, lastUserMessageId]);
        }
    }, [hasFailure, lastUserMessageId]);

    return failedIds;
};
